import {IModelValidator} from "@kta20-core/interfaces/i-model-validator";
import {IValidationMessage} from "@kta20-core/interfaces/i-validation-message";
import {CustomError} from "@kta20-core/errors/custom-error";
import {validator} from "@kta20-core/models/validator-customized";

export abstract class BaseModel implements IModelValidator{

    //defined once for all classes and instances
    static setValidatorLanguage(languageAndCountryCode: string='en-US') {
        validator.setLanguageAndCountryCode(languageAndCountryCode);
    }

    validationMap = {};

    /**
     *
     * @param props : default null, to validate everything must be validated by default in the class
     */
    //TODO: add a language optional param so that strings validation
    // can be language-aware (eg. take into account characters with accents )
    validate(props: string[]=null): IValidationMessage[] {
        const results:IValidationMessage[] = [];

        props = props || Object.keys(this.validationMap);

        props.forEach(prop=>{
            if(this[prop]===undefined || this.validationMap[prop]===undefined)
                throw new CustomError(`Cannot validate "${prop}", missing in model or validation map.`);

            const validationMessage = this.validationMap[prop]();
            if(validationMessage) results.push( validationMessage );
        });

        return results;
    }

    isValid(): boolean {
        return this.validate().length===0;
    }

    toDTO():Object {
        const dto = Object.assign({}, this);
        delete dto.validationMap;
        return dto;
    }



}